import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function FixedAddToCart({ evento, responsive }) {

  // console.log("FixedAddToCart - evento:", evento);
  return (
    <div className={`${responsive} sticky w-full z-[80]`}>
      <div className="w-full bg-aw-bluedark border-t border-aw-green p-2 sm:p-4 flex items-center justify-center">
        <div className="w-full lg:w-1/2 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src={evento?.imgEvento}
              alt={evento?.nombre}
              className="hidden sm:block sm:w-12 sm:h-12 rounded-lg object-cover bg-aw-bluegray"
            />
            <div className="flex flex-col text-white">
              <h4 className="text-sm font-semibold line-clamp-1">
                {evento?.nombre}
              </h4>
              <span className="text-xs">
                <FontAwesomeIcon
                  icon={"fa-solid fa-map-marker-alt"}
                  className="text-red-500 mr-1"
                />
                {evento?.direccion}
              </span>
            </div>
          </div>
          {/* TODO: Agregar funcionalidad que al momento de pulsar y no haber tickets agregados, hacer scroll al lugar de los tickets para que el usuario los agregue */}
          <button className="bg-aw-green text-aw-bluedark px-4 py-2 rounded-full font-bold hover:bg-aw-bluedark hover:text-aw-green border border-aw-green transition text-center text-xs sm:text-sm">
            Agregar Ticket{" "}
            <FontAwesomeIcon
              icon={"fa-solid fa-cart-shopping"}
              className="ml-2"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
